import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { ContentToolsModule } from '../../../shell/content-tools/content-tools.module';
import { ListDisplayStudentModule } from '../list-display/list-display-student/list-display-student.module';
import { AcademicListComponent } from './academic-list.component';
import { AcademicMadLibModule } from './academic-mad-lib/academic-mad-lib.module';
import { AcademicService } from './academic.service';

@NgModule({
  declarations: [AcademicListComponent],
  imports: [
    AcademicMadLibModule,
    CommonModule,
    MatExpansionModule,
    MatSelectModule,
    MatGridListModule,
    FormsModule,
    ListDisplayStudentModule,
    MatMenuModule,
    ContentToolsModule,
  ],
  exports: [AcademicListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [AcademicService],
})
export class AcademicListModule {
  /** */
}
